/* Keyboard support for the native details menu; lifecycle-safe in the theme editor. */
if (!customElements.get('n-navigation')) {
  customElements.define('n-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.headerObserver?.disconnect();
      const headerSection=this.closest('.n-header-section');
      if(headerSection && 'ResizeObserver' in window){
        this.headerObserver=new ResizeObserver(()=>document.documentElement.style.setProperty('--n-header-offset',`${headerSection.getBoundingClientRect().height}px`));
        this.headerObserver.observe(headerSection);
      }
      const details=this.querySelector('.n-menu');
      const summary=details?.querySelector(':scope > summary');
      const panel=details?.querySelector('.n-menu__panel');
      if(!details || !summary || !panel) return;
      const close=()=>{details.open=false;summary.focus();};
      this.querySelector('[data-menu-close]')?.addEventListener('click',close,options);
      details.addEventListener('toggle',()=>{
        summary.setAttribute('aria-expanded',String(details.open));
        if(details.open){panel.setAttribute('aria-modal','true');panel.querySelector('[data-menu-close]')?.focus();}
        else panel.removeAttribute('aria-modal');
      },options);
      document.addEventListener('pointerdown',event=>{
        if(details.open && !panel.contains(event.target) && !summary.contains(event.target))close();
      },options);
      panel.addEventListener('keydown',event=>{
        if(event.key==='Escape'){event.preventDefault();close();return;}
        if(event.key!=='Tab')return;
        const focusable=[...panel.querySelectorAll('a[href],button:not([disabled]),summary,select,input:not([disabled]),[tabindex="0"]')].filter(el=>el.getClientRects().length);
        const first=focusable[0],last=focusable.at(-1);
        if(event.shiftKey && document.activeElement===first){event.preventDefault();last?.focus();}
        else if(!event.shiftKey && document.activeElement===last){event.preventDefault();first?.focus();}
      },options);
      panel.addEventListener('click',event=>{if(event.target.closest('a[href]'))details.open=false;},options);
    }
    disconnectedCallback(){this.controller?.abort();this.headerObserver?.disconnect();}
  });
}
if(!customElements.get('n-newsletter-tab')){
  customElements.define('n-newsletter-tab',class extends HTMLElement{
    connectedCallback(){this.controller?.abort();this.controller=new AbortController();this.querySelector('[data-tab-close]')?.addEventListener('click',()=>{this.hidden=true;},{signal:this.controller.signal});}
    disconnectedCallback(){this.controller?.abort();}
  });
}
